import { CardTypes } from 'state/payment/types';

const fallbackPaymentMethodCardTypes = {
  mc: CardTypes.MASTERCARD,
  visa: CardTypes.VISA,
  amex: CardTypes.AMEX,
  discover: CardTypes.DISCOVER,
  jcb: CardTypes.JCB,
  diners: CardTypes.DINERS_CLUB,
};

/**
 * We are attempting to map our payment processor cardTypes to our FE CardType's.
 *
 * NOTE: This is intended to map the returned cardType for credit payment methods from the userAccounts query.
 */
export const mapPaymentMethodCardTypes = (paymentMethodCardType: string): CardTypes | undefined => {
  // check for all original card types, mostly first data values
  if (CardTypes[paymentMethodCardType]) {
    return CardTypes[paymentMethodCardType];
  }
  // check for payment processor card types
  // NOTE: in the future we may need to expand this
  return fallbackPaymentMethodCardTypes[paymentMethodCardType];
};
